import { createMutationAtomFactory } from '~/shared/providers/api/createMutationAtomFactory';

export const loadMarkAsVoidedAtom = createMutationAtomFactory(
  'trade.loadMarkAsVoided',
  (params: { loadId?: string; voidReason?: string }) => ({
    tradeLoadVoid: {
      __args: {
        id: params.loadId ?? '',
        voidReason: params.voidReason,
      },
    },
  }),
  {
    skipQueue: true,
  },
);
